module.exports = __webpack_public_path__ + "static/media/11NEPAD5.52db5b3f.jpg";